import classNames from 'classnames';
import React from 'react';
import { errorIcon, errorText, primary, primaryBlue, successGlowText, warningGlowBorder, warningIcon, white } from '../Styles/Colours';
import styles from './AlertBanner.module.css';
import { Button, ButtonMode, ButtonVariant } from './Button';
import { AlertIcon, AlertIconRound, CloseIcon, ConfirmedIcon, InfoIcon, WarningCircleIcon } from './Icons';
export var AlertBannerTypes;
(function (AlertBannerTypes) {
    AlertBannerTypes[AlertBannerTypes["Prompt"] = 0] = "Prompt";
    AlertBannerTypes[AlertBannerTypes["Warn"] = 1] = "Warn";
    AlertBannerTypes[AlertBannerTypes["Error"] = 2] = "Error";
    AlertBannerTypes[AlertBannerTypes["Success"] = 3] = "Success";
})(AlertBannerTypes || (AlertBannerTypes = {}));
export function AlertBanner(props) {
    var _a, _b, _c, _d;
    var promptType = props.promptType, promptMessage = props.promptMessage, infoLine = props.infoLine, onDismissAlert = props.onDismissAlert, multiline = props.multiline, promptExtraInfo = props.promptExtraInfo, buttonSize = props.buttonSize, center = props.center;
    var containerClasses = classNames(styles.alertBase, props.classNames, (_a = {},
        _a[styles.verticalSpace] = props.verticalSpace,
        _a[styles.invert] = props.invertColours,
        _a[styles.alertPrompt] = promptType === AlertBannerTypes.Prompt,
        _a[styles.alertWarn] = promptType === AlertBannerTypes.Warn,
        _a[styles.alertError] = promptType === AlertBannerTypes.Error,
        _a[styles.alertSuccess] = promptType === AlertBannerTypes.Success,
        _a[styles.center] = center,
        _a[styles.lowerHeight] = props.lowerHeight,
        _a[styles.noBorder] = props.noBorder,
        _a[styles.moreSpecific] = props.noBorder,
        _a));
    var iconContainer = classNames(styles.alertIconContainer, (_b = {},
        _b[styles.center] = center,
        _b[styles.multiline] = multiline,
        _b[styles.iconImage] = !!props.iconImage,
        _b));
    var textContainer = classNames(styles.textContainer, (_c = {},
        _c[styles.center] = center,
        _c[styles.multiline] = multiline,
        _c));
    var icon;
    if (props.iconImage) {
        icon = React.createElement("img", { src: props.iconImage, alt: '', className: styles.iconImage });
    }
    else if (promptType === AlertBannerTypes.Warn) {
        icon = React.createElement(WarningCircleIcon, { size: '20', color: props.invertColours ? white : warningIcon });
    }
    else if (promptType === AlertBannerTypes.Error) {
        icon = props.roundIcon ? (React.createElement(AlertIconRound, { size: '20', color: props.invertColours ? white : errorIcon })) : (React.createElement(AlertIcon, { size: '20', color: props.invertColours ? white : errorIcon }));
    }
    else if (promptType === AlertBannerTypes.Success) {
        icon = React.createElement(ConfirmedIcon, { size: '20', color: props.invertColours ? white : successGlowText });
    }
    else {
        icon = React.createElement(InfoIcon, { size: '20', color: props.invertColours ? white : primaryBlue });
    }
    var infoLineClasses = classNames(styles.info, (_d = {}, _d[styles.noPromptMessage] = !promptMessage, _d));
    var closeButtonVariant = ButtonVariant.info;
    var closeIconColour = primary;
    if (onDismissAlert) {
        closeIconColour =
            promptType === AlertBannerTypes.Error
                ? errorText
                : promptType === AlertBannerTypes.Warn
                    ? warningGlowBorder
                    : promptType === AlertBannerTypes.Success
                        ? successGlowText
                        : primary;
        closeButtonVariant =
            promptType === AlertBannerTypes.Error
                ? ButtonVariant.danger
                : promptType === AlertBannerTypes.Warn
                    ? ButtonVariant.warning
                    : promptType === AlertBannerTypes.Success
                        ? ButtonVariant.success
                        : ButtonVariant.info;
    }
    return (React.createElement("div", { className: containerClasses },
        React.createElement("div", { className: iconContainer }, icon),
        React.createElement("div", { className: textContainer },
            (!!promptMessage || !!promptExtraInfo) && (React.createElement("div", { className: styles.alertMessage },
                promptMessage,
                promptExtraInfo && React.createElement("span", { className: styles.alertExtraInfo },
                    " ",
                    promptExtraInfo))),
            !!infoLine && React.createElement("div", { className: infoLineClasses }, infoLine)),
        onDismissAlert && (React.createElement("div", { className: styles.closeButton },
            React.createElement(Button, { size: buttonSize, onClick: onDismissAlert, iconOnly: true, mode: ButtonMode.text, variant: closeButtonVariant, testId: 'dismiss', subtleShadeOnHover: true, noShadowOnHover: true },
                React.createElement(CloseIcon, { color: closeIconColour, size: '16' }))))));
}
